import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M4.767 9.188 2.684 7.105a.43.43 0 0 1 .003-.608 3.46 3.46 0 0 1 3.668-.798l3.42-3.021a2.73 2.73 0 0 1 .714-2.62.194.194 0 0 1 .274-.002l5.18 5.181a.194.194 0 0 1 0 .274 2.73 2.73 0 0 1-2.62.714L10.3 9.645a3.46 3.46 0 0 1-.798 3.668.43.43 0 0 1-.608.003l-2.083-2.083-2.047 2.047q-.36.36-.773.656C3.232 14.48.5 16 .288 15.712s1.232-2.945 1.776-3.704q.296-.413.656-.773zm6.04-6.135a.12.12 0 0 0 .038-.122l-.133-.506a1.75 1.75 0 0 1-.016-.82c.019-.088.126-.114.19-.051l3.56 3.56c.063.064.037.171-.05.19-.271.06-.552.054-.82-.016l-.507-.133a.12.12 0 0 0-.122.038L9.383 9.228a.49.49 0 0 0-.091.493l.103.273a2.49 2.49 0 0 1-.233 2.215l-5.37-5.371a2.49 2.49 0 0 1 2.214-.233l.273.103a.49.49 0 0 0 .493-.091zM5.448 9.87l-1.99 1.99q-.36.36-.656.773l-1.425 1.99 1.99-1.425a6 6 0 0 0 .773-.656l1.99-1.99z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgPin = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="pin" {...props} />;
export default SvgPin;
